<template>
  <div v-show="pageShow">
    <Header/>
    <div class="content-wrapper">
      <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1 class="m-0 text-dark">สมาชิก</h1>
            </div>
          </div>
        </div>
      </div>
      <!-- Content body. -->
      <section class="content">
        <div class="container-fluid">
          <div class="card">
            <div class="card-header d-flex">
              <div class="col-2"></div>
              <div class="col-10 text-right">
                <button class="btn btn-sm btn-primary" @click="addUser()">
                  เพิ่มสมาชิก
                  <i class="fas fa-plus"></i>
                </button>
              </div>
            </div>
            <div class="card-body">
              <div>
                <table id="dataTable" class="table table-hover table-striped table-bordered">
                  <thead class="thead-light">
                    <tr>
                      <th>ลำดับ</th>
                      <th>ชื่อลูกค้า</th>
                      <th>เบอร์โทร</th>
                      <th>อีเมล์</th>
                      <th>วันที่</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(user,index) in users" :key="user.index">
                      <td>{{++index}}</td>
                      <td>{{user.cus_name}} {{user.cus_lastname}}</td>
                      <td>{{user.cus_tel}}</td>
                      <td>{{user.cus_mail}}</td>
                      <td>{{user.created_at}}</td>
                      <td>
                        <button
                          class="btn btn-link btn-sm text-warning"
                          title="Edit data this user."
                          @click="editUser(user)"
                        >
                          <i class="fas fa-user-edit"></i> Edit
                        </button>
                        <button
                          class="btn btn-link btn-sm text-danger"
                          title="Delete data this user."
                          @click="deleteUser(user.cus_id)"
                        >
                          <i class="fas fa-trash-alt"></i> Delete
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- Modal -->
      <div class="modal" id="modalUser">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">{{titleForm}}</h4>
              <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <form @submit.prevent="actionForm ? updateUser() : saveUser()">
              <div class="modal-body">
                <div class="form-group">
                  <label>ชื่อ</label>
                  <input type="text" v-model="form.cus_name" placeholder="Enter Username" class="form-control form-control-sm" required>
                </div>
                <div class="form-group">
                  <label>นามสกุล</label>
                  <input type="text" v-model="form.cus_lastname" placeholder="Enter Username" class="form-control form-control-sm" required>
                </div><div class="form-group">
                  <label>เบอร์โทรศัพท์</label>
                  <input type="number" v-model="form.cus_tel" placeholder="Enter Username" class="form-control form-control-sm" minlength="10" required>
                </div><div class="form-group">
                  <label>อีเมล์</label>
                  <input type="email" v-model="form.cus_mail" placeholder="Enter Username" class="form-control form-control-sm" required>
                </div>
                <div class="form-group">
                  <label>Password</label>
                  <input type="password" v-model="form.cus_password" placeholder="Enter Password" class="form-control form-control-sm" pattern=".{6,}" title="6 or more characters">
                </div>
              </div>
              <div class="modal-footer">
                <button class="btn btn-success" type="submit">{{btnSubmit}}</button>
                <button type="button" class="btn btn-danger" data-dismiss="modal">ยกเลิก</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/HeaderBack";
export default {
  components: {
    Header
  },
  data() {
    return {
      pageShow: false,
      users: {},
      titleForm: "",
      btnSubmit: "",
      actionForm: false,
      form: new Form({
        cus_id: "",
        cus_name: "",
        cus_lastname:'',
        cus_tel:'',
        cus_mail:'',
        cus_password: ""
      })
    };
  },
  beforeCreate() {
    this.axios
      .post(
        "http://pgm01.toonjob.com/2019/BannKlong/project/checkBeforeLogin",
        {
          keyid: this.$session.get("keyid"),
          keyserial: this.$session.get("keyserial"),
          keytoken: this.$session.get("keytoken")
        }
      )
      .then(response => {
        if (response.data.checkLogin === 0) {
          this.pageShow = false;
          window.location.href = "/pageLogin";
        } else {
          this.pageShow = true;
        }
      });
  },
  methods: {
    authentication(){
      return {'keyid': this.$session.get('keyid'), 'keyserial': this.$session.get('keyserial'), 'keytoken':this.$session.get('keytoken')}
    },
    dataUsers() {
      this.axios
        .post("http://pgm01.toonjob.com/2019/BannKlong/project/dataCustomers", this.authentication())
        .then(response => {
          this.users = response.data;
          $(document).ready(function() {
            $("#dataTable").DataTable();
          });
        });
    },
    addUser() {
      $("#modalUser").modal("show");
      this.form.reset();
      this.titleForm = "เพิ่มสมาชิก";
      this.btnSubmit = "บันทึกข้อมูล";
      this.actionForm = false;
    },
    editUser(user) {
      this.form.fill(user);
      this.form.cus_password = "";
      $("#modalUser").modal("show");
      this.titleForm = "แก้ไขข้อมูลสมาชิก";
      this.btnSubmit = "แก้ไขและบันทึก";
      this.actionForm = true;
    },
    saveUser() {
      this.form
        .post("http://pgm01.toonjob.com/2019/BannKlong/project/addCustomers")
        .then(response => {
          toast.fire({
            type: response.data.type,
            title: response.data.message
          });
          $("#modalUser").modal("hide");
          Fire.$emit("AfterUsers");
        });
    },
    updateUser() {
      this.form
        .post("http://pgm01.toonjob.com/2019/BannKlong/project/updateCustomers")
        .then(response => {
          toast.fire({
            type: response.data.type,
            title: response.data.message
          });
          $("#modalUser").modal("hide");
          Fire.$emit("AfterUsers");
        });
    },
    deleteUser(id) {
      swal
        .fire({
          title: "Are you sure?",
          text: "You won't delete this user!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        })
        .then(result => {
          if (result.value) {
            this.axios
              .post("http://pgm01.toonjob.com/2019/BannKlong/project/deleteUser", {
                cus_id: id
              })
              .then(response => {
                swal.fire("Deleted!", response.data.message, "success");
                Fire.$emit("AfterUsers");
              });
          }
        });
    }
  },
  created() {
    this.$Progress.start();
    this.dataUsers();
    Fire.$on("AfterUsers", () => {
      this.dataUsers();
    });
    this.$Progress.finish();
  }
};
</script>


// WEBPACK FOOTER //
// src/backEnd/Customers.vue